export default 'launcher';
